export default __webpack_public_path__ + "static/media/checkmark-purple.82c27e51.svg";